export default __webpack_public_path__ + "static/media/reedem-point-icon.3dd1e418.svg";